export default {

    props: ['params'],

    data: function() {

        return {
            preload: false,
            is: {
                preloading: false
            }
        }

    },

    created: function() {

        if (this.preload) {

            this.is.preloading = true

            this.$api.request(this.preload, {
                id: this.params.preload
            }).then(function(json) {

                this.$emit('preloaded', json)

                this.is.preloading = false

            }.bind(this))

        }

    },
    
    methods: {

        processEvents: function() {

            var events = this.params.events || []

            this.$_.each(events, function(event) {

                this.$pubsub.$emit(event)

            }.bind(this))

        }

    }

}